import {
  AA, Functions, Method, S3,
} from 'sdk';

class MediaUploader {
  uploadNewMediaToS3(params) {
    return new Promise((resolve, reject) => {
      const parameters = { ...params };
      this.getS3Params(params).then((s3Params) => {
        parameters.s3Params = s3Params;
        return this.uploadMediaToS3(parameters);
      }).then(() => {
        resolve(parameters.s3Params.mediaId);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  getS3Params(params) {
    return new Promise((resolve, reject) => {
      AA.api(
        Functions.generateUploadParameters,
        Method.post,
        { amazonAuthorId: params.amazonAuthorId, mediaType: params.mediaType },
      ).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  uploadMediaToS3(params) {
    return new Promise((resolve, reject) => {
      const uploadToS3 = params.file ? S3.uploadMediaFileToS3 : S3.uploadMediaURIToS3;
      uploadToS3.call(S3, params).then(() => {
        resolve();
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default new MediaUploader();
